import React from 'react'


const iframeStyle = {
    'background': 'transparent',
    'border': '1px solid #ccc'
};

const divStyle = {
    width: "100%",
    height:"100%"
};

const Referrals = () =>
    <div style={divStyle}>
        <iframe className="airtable-embed" title="form" src="https://airtable.com/embed/shrIGppvsKOOEMjcl?backgroundColor=greenLight"
                frameBorder="0" onmousewheel="" width="100%" height="100%"
                style={iframeStyle}
        >
        </iframe>
    </div>
export  default Referrals


// WEBPACK FOOTER //
// ./src/pages/referrals.js